import { PText, PTextFieldWrapper } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { TEXTS } from '../../config/texts'

import styles from './departmentfield.module.css'

type Props = {
  defaultValue?: string
}

const DepartmentField = ({ defaultValue }: Props) => {
  const newDefaultValue = defaultValue?.replace(/FD/gi, '')
  const { register, errors, setValue } = useFormContext()

  React.useEffect(() => {
    if (defaultValue) {
      setValue('department', newDefaultValue, {
        shouldValidate: true
      })
    }
  }, [defaultValue])

  React.useEffect(() => {
    register('department', {
      required: true,
      maxLength: {
        value: 3,
        message: TEXTS.DEPARTMENT_MAX_LENGTH_MESSAGE
      }
    })
  }, [register])

  return (
    <PTextFieldWrapper
      label={TEXTS.DEPARTMENT_LABEL}
      className={styles.textfield}
      state={errors.department ? 'error' : 'none'}
      message={errors.department?.type === 'maxLength' ? errors.department?.message : 'Das Feld wird benötigt.'}
      unit={TEXTS.DEPARTMENT_INPUT_MASK}
    >
      <input
        type='text'
        required
        name='department'
        className={clsx(styles.fiField, { [styles.error]: errors.department })}
        placeholder={TEXTS.DEPARTMENT_PLACEHOLDER}
        defaultValue={newDefaultValue}
        ref={register}
      />
    </PTextFieldWrapper>
  )
}

export default DepartmentField
